<template>
  <div style="margin:0;padding:0;width:100%;display:flex;flex-direction:column;">

    <!-- Sticky title -->
    <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0;">
      <h2 class="pt-3 pb-2" style="letter-spacing:normal;">
        {{ $t("pmselfservice.managerview") }}
      </h2>
    </div>

    <v-container fluid class="pa-0 pb-6">
      <v-row>
        <!-- KPI Section -->
        <v-col cols="12" md="4" class="pr-3">
          <v-card outlined class="section-header-card mb-2">
            <v-card-text class="pa-3">
              <div class="d-flex align-center">
                <v-icon size="36" color="#1261a0" class="mr-3">mdi-target</v-icon>
                <div>
                  <div class="section-title">KPI</div>
                  <div class="section-desc">View all targets defined for reporting staff for all periods.</div>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <div v-if="kpiExercises.length > 0">
            <v-card
              v-for="(kpi, index) in kpiExercises"
              :key="'kpi-' + index"
              outlined
              class="record-card mb-2"
            >
              <div class="record-card-body">
                <div class="record-title mb-1">{{ kpi.title }}</div>
                <div class="record-meta mb-1">
                  {{ $t("forperiodfrom") }}
                  <span class="font-weight-bold">{{ kpi.startDate }}</span>
                  {{ $t("until2") }}
                  <span class="font-weight-bold">{{ kpi.endDate }}</span>
                </div>
              </div>
              <v-card-actions class="justify-end pt-0">
                <v-btn color="primary" small @click="viewDetails(kpi)">
                  {{ $t('pmmoderation.viewdetails') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
          <div v-else>
            <v-card outlined class="empty-card">
              <v-card-text class="pa-6 text-center">
                <div class="record-meta">No records found.</div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>

        <!-- Review Records Section -->
        <v-col cols="12" md="4" class="pr-3">
          <v-card outlined class="section-header-card mb-2">
            <v-card-text class="pa-3">
              <div class="d-flex align-center">
                <v-icon size="36" color="#1261a0" class="mr-3">mdi-clipboard-text-outline</v-icon>
                <div>
                  <div class="section-title">Review Records</div>
                  <div class="section-desc">Confirmation periodic review records for all reporting staff can be found here.</div>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <div v-if="reviewExercises.length > 0">
            <v-card
              v-for="(review, index) in reviewExercises"
              :key="'review-' + index"
              outlined
              class="record-card mb-2"
            >
              <div class="record-card-body">
                <div class="record-title mb-1">{{ review.title }}</div>
                <div class="record-meta mb-1">
                  {{ $t("forperiodfrom") }}
                  <span class="font-weight-bold">{{ review.startDate }}</span>
                  {{ $t("until2") }}
                  <span class="font-weight-bold">{{ review.endDate }}</span>
                </div>
              </div>
              <v-card-actions class="justify-end pt-0">
                <v-btn color="primary" small @click="viewDetails(review)">
                  {{ $t('pmmoderation.viewdetails') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
          <div v-else>
            <v-card outlined class="empty-card">
              <v-card-text class="pa-6 text-center">
                <div class="record-meta">No records found.</div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>

        <!-- Reward Section -->
        <v-col cols="12" md="4" class="pr-3">
          <v-card outlined class="section-header-card mb-2">
            <v-card-text class="pa-3">
              <div class="d-flex align-center">
                <v-icon size="36" color="#1261a0" class="mr-3">mdi-trophy-outline</v-icon>
                <div>
                  <div class="section-title">Reward</div>
                  <div class="section-desc">Performance based reward records.</div>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <div v-if="rewardExercises.length > 0">
            <v-card
              v-for="(reward, index) in rewardExercises"
              :key="'reward-' + index"
              outlined
              class="record-card mb-2"
            >
              <div class="record-card-body">
                <div class="record-title mb-1">{{ reward.title }}</div>
                <div class="record-meta mb-1">
                  {{ $t("forperiodfrom") }}
                  <span class="font-weight-bold">{{ reward.startDate }}</span>
                  {{ $t("until2") }}
                  <span class="font-weight-bold">{{ reward.endDate }}</span>
                </div>
              </div>
              <v-card-actions class="justify-end pt-0">
                <v-btn color="primary" small @click="viewDetails(reward)">
                  {{ $t('pmmoderation.viewdetails') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
          <div v-else>
            <v-card outlined class="empty-card">
              <v-card-text class="pa-6 text-center">
                <div class="record-meta">No records found.</div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      kpiExercises: [],
      reviewExercises: [],
      rewardExercises: [],
      URLS: [
        "/ss/mystaffkpiexercise/",
        "/ss/mystaffreviewexercise/",
        "/ss/mystaffrewardsimulate/"
      ]
    };
  },

  methods: {
    viewDetails(item) {
      this.$router.push({
        name: "selfservicemystaffdetails",
        params: { list: item },
      });
    },

    loadMyStaffExercise() {
      const vm = this;
      for (let i = 0; i < vm.URLS.length; i++) {
        const idx = i;
        this.$store.dispatch("get", { url: vm.URLS[idx] + this.$store.getters.staffId })
          .then(function (res) {
            const category = idx === 0 ? "KPI" : idx === 1 ? "Review" : "Reward";
            res.data.rec.forEach((item) => {
              item.category = category;
              if (item.startDate) item.startDate = moment(item.startDate).format("DD-MM-YYYY");
              if (item.endDate) item.endDate = moment(item.endDate).format("DD-MM-YYYY");
            });
            if (idx === 0) vm.kpiExercises = res.data.rec;
            else if (idx === 1) vm.reviewExercises = res.data.rec;
            else vm.rewardExercises = res.data.rec;
          })
          .catch(function (err) {
            vm.errMsg = err;
          });
      }
    },
  },

  mounted() {
    this.loadMyStaffExercise();
  },
};
</script>

<style scoped>
.section-header-card {
  background-color: #F1F5F9 !important;
  border-radius: 10px !important;
  border-color: #E2E8F0 !important;
  min-height: 90px;
}

.section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #1a3a5c;
  letter-spacing: normal;
  line-height: 1.3;
}

.section-desc {
  font-size: 0.75rem;
  color: #546e7a;
  letter-spacing: normal;
  line-height: 1.4;
  margin-top: 2px;
}

.record-card {
  border-radius: 10px !important;
  color: #1a3a5c;
}

.record-card-body {
  padding: 12px 16px 4px 16px;
}

.record-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1a3a5c;
  letter-spacing: normal;
  line-height: 1.4;
}

.record-meta {
  font-size: 0.82rem;
  color: #546e7a;
  letter-spacing: normal;
  line-height: 1.4;
}

.empty-card {
  border-radius: 10px !important;
}
</style>
